const stats = [
  { value: '12,680+', label: '累计爆料' },
  { value: '850万+', label: '月活吃瓜' },
  { value: '24h', label: '不打烊更新' },
];

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[700px] md:h-[740px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20gradient%20background%20with%20warm%20coral%20and%20deep%20burgundy%20tones%2C%20subtle%20geometric%20texture%20overlay%2C%20modern%20editorial%20design%2C%20dramatic%20lighting%20with%20soft%20glow%20at%20center%2C%20no%20text%2C%20no%20people%2C%20cinematic%20atmosphere%2C%20rich%20depth%20and%20contrast%2C%20sophisticated%20dark%20aesthetic%20suitable%20for%20entertainment%20news%20platform%20background&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-[58%] text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-400 text-sm font-medium mb-5 whitespace-nowrap">
              全网吃瓜第一站
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4 max-w-xl">
              51吃瓜黑料 · 网红爆料不打烊
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-light mb-2 max-w-lg">
              网曝门现场、明星塌房记录、博主反差合集
            </p>

            <div className="space-y-2 max-w-lg">
              <p className="text-sm md:text-base text-white/60 leading-relaxed">
                51吃瓜黑料每日追踪全网最新网红塌房黑料与大赛现场，覆盖明星爆料、博主反差记录与网曝门事件。网站不打烊持续更新，一手吃瓜资源一站到位。
              </p>
              <p className="text-sm md:text-base text-white/60 leading-relaxed">
                从热搜话题到冷门猛料，51吃瓜黑料网址入口为你整理最全爆料合集。无论你想在线观看最新瓜料还是回顾经典名场面，这里都是你的吃瓜根据地。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-6 md:gap-10 mt-7 justify-center lg:justify-start">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-white whitespace-nowrap">
                    {s.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/50 mt-1 whitespace-nowrap">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 justify-center lg:justify-start">
              <a
                href="#cards"
                className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer shadow-lg shadow-primary-500/30"
              >
                立即吃瓜
              </a>
              <a
                href="#ranking"
                className="whitespace-nowrap px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors duration-200 cursor-pointer"
              >
                热搜榜单
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[42%] flex justify-center">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20composition%20with%20warm%20coral%20red%20and%20dark%20tones%2C%20geometric%20shapes%20layered%20with%20translucent%20overlays%2C%20modern%20magazine%20cover%20aesthetic%2C%20bold%20graphic%20elements%2C%20dramatic%20contrast%2C%20trending%20news%20visual%20metaphor%2C%20no%20text%2C%20no%20people%2C%20clean%20sophisticated%20design%20suitable%20for%20entertainment%20platform%20hero%20visual&width=800&height=1000&seq=hero-visual-main&orientation=portrait"
                alt="51吃瓜黑料"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}